import { Suspense, lazy, useEffect } from "react";
import "rodal/lib/rodal.css";
import { Routes, Route } from "react-router-dom";
import Loading from "./sharedComponents/Loading";
import Container from "./pages/Container";
import RedirectHome from "./sharedComponents/RedirectHome";
import { General404 } from "./pages/Error404";
import "react-toastify/dist/ReactToastify.min.css";
import { getPersistor } from "@rematch/persist";
import { PersistGate } from "redux-persist/lib/integration/react";
import ErrorModal from "./sharedComponents/ErrorModal";
import { store } from "./store";
import { Provider } from "react-redux";
// import ProductView from "./pages/ProductView";
// import Products from "./pages/Products";
import Checkout from "./pages/Checkout";
// import CheckoutSuccess from "./pages/CheckoutSuccess/CheckoutSuccess";

const Products = lazy(() => import("./pages/Products"));
const ProductView = lazy(() => import("./pages/ProductView"));
const CheckoutSuccess = lazy(() => import("./pages/CheckoutSuccess"));

function App() {
  const persistor = getPersistor();

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Suspense fallback={Loading}>
          <ErrorModal />

          <Routes>
            {/* <Route element={<RedirectHome />} path="/" /> */}
            <Route element={<Container />} path="/:slug">
              <Route
                element={
                  <Suspense fallback={Loading}>
                    <Products />
                  </Suspense>
                }
                path="/:slug"
              />
              <Route
                element={
                  <Suspense fallback={Loading}>
                    <Products />
                  </Suspense>
                }
                path="/:slug/:index"
              />
              <Route
                element={
                  <Suspense fallback={Loading}>
                    <ProductView />
                  </Suspense>
                }
                path="/:slug/p/:id"
              />
              <Route element={<Checkout />} path="/:slug/checkout" />
              <Route
                element={
                  <Suspense fallback={Loading}>
                    <CheckoutSuccess />
                  </Suspense>
                }
                path="/:slug/success"
              />
            </Route>
            <Route element={<General404 />} path="*" />
          </Routes>
        </Suspense>
      </PersistGate>
    </Provider>
  );
}

export default App;
